module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Utcanév, házszám","flags":["TRACK"],"track":"Street Address"}}